
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.4 2.75a1.917 1.917 0 00-1.917 1.917.75.75 0 01-.75.75H3.067a.317.317 0 00-.317.316v11.2a.317.317 0 00.317.317H8.4a.75.75 0 010 1.5H3.067a1.817 1.817 0 01-1.817-1.817v-11.2a1.817 1.817 0 011.817-1.816h2a3.417 3.417 0 016.666 0h2a1.816 1.816 0 011.817 1.816v1.6a.75.75 0 01-1.5 0v-1.6a.317.317 0 00-.317-.316h-2.666a.75.75 0 01-.75-.75A1.917 1.917 0 008.4 2.75zM4.45 8.933a.75.75 0 01.75-.75h3.733a.75.75 0 110 1.5H5.2a.75.75 0 01-.75-.75zm0 2.667a.75.75 0 01.75-.75h2.133a.75.75 0 010 1.5H5.2a.75.75 0 01-.75-.75zm.75 1.917a.75.75 0 000 1.5h2.133a.75.75 0 000-1.5H5.2zM7.681 3.68A1.017 1.017 0 119.12 5.12 1.017 1.017 0 017.681 3.68zm2.505 6.505a5.016 5.016 0 117.095 7.094 5.016 5.016 0 01-7.095-7.094zm3.547.03a3.517 3.517 0 100 7.034 3.517 3.517 0 000-7.033zm2.502 2.726a.75.75 0 10-1.2-.9l-1.916 2.556-.89-.89a.75.75 0 00-1.061 1.06l1.066 1.066a1.284 1.284 0 001.934-.136h.001l2.066-2.756z"}})])
          )
        }
      }
    